"use client";

import React, { useContext } from 'react';
import ActionButton from '../../_util/ActionButton';
import { ModalContext } from '../context';
const ConfirmCancelBtn = () => {
  const _useContext = useContext(ModalContext),
    autoFocusButton = _useContext.autoFocusButton,
    cancelButtonProps = _useContext.cancelButtonProps,
    cancelTextLocale = _useContext.cancelTextLocale,
    isSilent = _useContext.isSilent,
    mergedOkCancel = _useContext.mergedOkCancel,
    rootPrefixCls = _useContext.rootPrefixCls,
    close = _useContext.close,
    onCancel = _useContext.onCancel,
    onConfirm = _useContext.onConfirm;
  return mergedOkCancel ? ( /*#__PURE__*/React.createElement(ActionButton, {
    isSilent: isSilent,
    actionFn: onCancel,
    close: function () {
      close === null || close === void 0 ? void 0 : close.apply(void 0, arguments);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, cancelTextLocale)) : null;
};
export default ConfirmCancelBtn;